'use client';

import {
	type NavigationTab,
	NavigationTabs,
} from '@/components/NavigationTabs';

export const ForYouTabs = () => {
	const TabList: NavigationTab[] = [
		{
			id: 'curiosity',
			label: 'Curiosity',
			link: '/for_you/curiosity',
		},
		{
			id: 'follow_up',
			label: 'Follow-up',
			link: '/for_you/follow_up',
		},
	] as const;
	return <NavigationTabs tabs={TabList} className="mb-1" />;
};
